import ImagePicker from 'components/ImagePicker'
import { buildTranslate } from 'locales'
import React from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import UrlPicker from 'scenes/Cms/components/UrlPicker'
import { selectLinkValidation } from 'selectors/validation'
import { BlockData } from './index'

type Props = {
  index: number
  id: string
  data: BlockData
}

const t = buildTranslate('cms.content.content_blocks.block_item')

const BlockItem: React.FC<Props> = ({ id, data, index }) => {
  const { url, image } = data
  const headerValidation = useSelector(selectLinkValidation)

  return (
    <div>
      <p className="mb-m small-caps-2 bold">
        {t('title', { index: index + 1 })}
      </p>
      {headerValidation && (
        <ImagePicker
          className="mb-l"
          name={`${id}.image`}
          value={image}
          validations={{
            image: true,
          }}
          validationErrors={{
            image: I18n.t('validations.is_required'),
          }}
          imageValidations={headerValidation}
        />
      )}
      <UrlPicker id={`${id}`} type="button" url={url} />
    </div>
  )
}

export default BlockItem
